import { render, staticRenderFns } from "./SearchBoxSwitcher.vue?vue&type=template&id=5b957abe"
import script from "./SearchBoxSwitcher.vue?vue&type=script&lang=js"
export * from "./SearchBoxSwitcher.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports